import React from 'react';

const SALES_HISTORY_OPTIONS = [
  { value: '3', label: '3 Weeks (W1, W2, W3)' },
  { value: '4', label: '4 Weeks (W1, W2, W3, W4)' },
  { value: '6', label: '6 Weeks' },
  { value: '8', label: '8 Weeks' },
];

const SALES_CONSIDERATIONS = [
  { key: 'includeClosingStock', label: 'Include Closing Stock' },
  { key: 'includeIssuedStock', label: 'Include Issued Stock' },
  { key: 'includeProductionStock', label: 'Include Production Stock' },
  { key: 'includeDamagedStock', label: 'Include Damaged Stock' },
  { key: 'includeReturnsStock', label: 'Include Returns Stock' },
];

function StepSetParameters({ wizardData, onChange }) {
  const params = wizardData.parameters || {};

  const updateParam = (key, value) => {
    onChange({ parameters: { ...params, [key]: value } });
  };

  return (
    <div className="space-y-6">
      <div>
        <h3 className="text-lg font-semibold text-gray-900">Step 3: Set Parameters</h3>
        <p className="mt-1 text-sm text-gray-500">
          Define the basic parameters for calculation and ordering.
        </p>
      </div>

      <div className="grid gap-6 lg:grid-cols-2">
        {/* Planning Parameters */}
        <div className="rounded-xl border border-gray-200 bg-white p-5">
          <h4 className="mb-4 text-sm font-semibold text-gray-800">Planning Parameters</h4>
          <div className="space-y-4">
            <label className="flex flex-col text-sm text-gray-700">
              <span>
                Lead Time (Days) <span className="text-red-600">*</span>
              </span>
              <input
                type="number"
                min="0"
                value={params.leadTimeDays ?? ''}
                onChange={(e) => updateParam('leadTimeDays', e.target.value)}
                placeholder="e.g. 2"
                className="mt-1 w-full rounded-lg border border-gray-200 bg-[#F7E5D5] px-3 py-2 text-sm focus:border-brand focus:outline-none focus:ring-1 focus:ring-brand"
              />
            </label>
            <label className="flex flex-col text-sm text-gray-700">
              <span>
                Buffer % <span className="text-red-600">*</span>
              </span>
              <input
                type="number"
                min="0"
                max="100"
                value={params.bufferPercent ?? ''}
                onChange={(e) => updateParam('bufferPercent', e.target.value)}
                placeholder="e.g. 20"
                className="mt-1 w-full rounded-lg border border-gray-200 bg-[#F7E5D5] px-3 py-2 text-sm focus:border-brand focus:outline-none focus:ring-1 focus:ring-brand"
              />
            </label>
            <label className="flex flex-col text-sm text-gray-700">
              <span>
                Projected Growth % (GC) <span className="text-red-600">*</span>
              </span>
              <div className="mt-1 flex items-center gap-2">
                <input
                  type="number"
                  min="0"
                  value={params.projectedGrowth ?? ''}
                  onChange={(e) => updateParam('projectedGrowth', e.target.value)}
                  placeholder="e.g. 10"
                  className="w-full rounded-lg border border-gray-200 bg-[#F7E5D5] px-3 py-2 text-sm focus:border-brand focus:outline-none focus:ring-1 focus:ring-brand"
                />
                <span className="shrink-0 text-sm text-gray-500">%</span>
              </div>
            </label>
            <label className="flex flex-col text-sm text-gray-700">
              <span>
                Sales History (Weeks) <span className="text-red-600">*</span>
              </span>
              <select
                value={params.salesHistoryWeeks ?? ''}
                onChange={(e) => updateParam('salesHistoryWeeks', e.target.value)}
                className="mt-1 w-full rounded-lg border border-gray-200 bg-[#F7E5D5] px-3 py-2 text-sm focus:border-brand focus:outline-none focus:ring-1 focus:ring-brand"
              >
                <option value="">Select weeks</option>
                {SALES_HISTORY_OPTIONS.map((opt) => (
                  <option key={opt.value} value={opt.value}>
                    {opt.label}
                  </option>
                ))}
              </select>
            </label>
          </div>
        </div>

        {/* Sales Consideration */}
        <div className="rounded-xl border border-gray-200 bg-white p-5">
          <h4 className="mb-4 text-sm font-semibold text-gray-800">Sales Consideration</h4>
          <div className="space-y-3">
            {SALES_CONSIDERATIONS.map((item) => (
              <label key={item.key} className="flex cursor-pointer items-center gap-2.5 text-sm text-gray-700">
                <input
                  type="checkbox"
                  checked={Boolean(params[item.key])}
                  onChange={(e) => updateParam(item.key, e.target.checked)}
                  className="h-4 w-4 rounded border-gray-300 text-brand accent-brand"
                />
                {item.label}
              </label>
            ))}
          </div>
        </div>
      </div>

      <div className="flex items-start gap-2 rounded-xl border border-blue-200 bg-blue-50 px-4 py-3">
        <svg className="mt-0.5 h-5 w-5 shrink-0 text-blue-600" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <circle cx="12" cy="12" r="10" />
          <line x1="12" y1="16" x2="12" y2="12" />
          <line x1="12" y1="8" x2="12.01" y2="8" />
        </svg>
        <p className="text-sm text-blue-800">
          These parameters will be used to calculate suggested and final order quantity.
        </p>
      </div>
    </div>
  );
}

export default StepSetParameters;
